// extracted by css-extract-rspack-plugin
export default {"wrapper":"_d97a5af0","image":"_26840344","isCover":"_e5e6ce54","fixedHeight":"_57680eca"};